<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 20px;">
          <div class="rowStyle">
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;">
              特别说明：本平台知晓国家法律，平台侧不会泄露用户填写的任何资料，且不会用于数据分析和广告商业业务。对于高度隐私信息，请用户收集完后自行删除。</div>
          </div>
          <div style="display: flex;flex-direction: column;">
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;">1.我已经有表格能使用本系统吗？</div>
            <div style="font-size:16px;padding-top: 20px;">可以,把您的表格导入系统中。用户填写好数据后，导出数据并把数据粘贴到您的表格中，即可完成数据收集工作。</div>
          </div>

          <div style="display: flex;flex-direction: column;">
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;">2.我没有现成的表格能用本系统吗？</div>
            <div style="font-size:16px;padding-top: 20px;">可以,您根据自己的需要制作一张收集表发给大家填写就可以了。用户填写好数据后导出数据即可。</div>
          </div>

          <div style="display: flex;flex-direction: column;">
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;">3.怎么获得客服支持？</div>
            <div style="font-size:16px;padding-top: 20px;">有问题直接在小程序的客服里问。如果没有联系到可以加微信 wx34424698 。 如果事情紧急可以拨打电话 19909408114. </div>
          </div>

          <div style="margin-top: 5px;font-size:18px;">
            <div style="font-weight: bold;">问:表格中已经有部分数据,需要填表人填写部分数据,怎么操作?</div>
            <div>答:将表格中的数据导入系统,把一到两列设置为领表凭证,如姓名、编号等,填表人录入凭证就可以领到自己应该填写的数据进行填写。</div>
          </div>
          <div style="margin-top: 5px;font-size:18px;">
            <div style="font-weight: bold;">问:能让一些数据不让修改吗,怎么操作?</div>
            <div>答:导入数据时把列名属性中的“能否修改”设为“禁止填表人修改”。</div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/read_me.vue